import {
  Alert,
  Modal,
  ModalContent,
  ModalFooter,
  useToaster
} from "@dealer-center/core-components";
import { SaveAndCancel } from "@dealer-center/core-custom-components";
import { useGetAccountId } from "@dealer-center/ddc-api-account-fetch";
import { InputWithTypeahead } from "@dealer-center/ddc-pages-account-search-react";
import { useState } from "react";
import styled from "styled-components";

const StyledInputArea = styled.div`
  width: 100%;
  display: flex;
`;

const StyledModalContent = styled(ModalContent)`
  padding: 0;
`;
interface PagesAccountCopyUiInputProps {
  performCopy: (destinationAccount: string) => void;
}

export const PagesAccountCopyUiInput = ({
  performCopy
}: PagesAccountCopyUiInputProps) => {
  const [nameInput, setNameInput] = useState("");
  const [showModal, setShowModal] = useState(false);
  const selectedAccount = useGetAccountId();
  const { toastError } = useToaster();
  return (
    <StyledInputArea>
      <InputWithTypeahead
        data-testid="copy-account"
        filterBy="id"
        id="copy-account"
        key={showModal ? "modal-open" : "modal-closed"}
        name="copy-account"
        placeholder="Search for an account"
        submitButtonContent="Copy"
        onSubmit={account => {
          if (account === selectedAccount) {
            toastError("You cannot copy an account to itself.");
            return;
          }
          if (account.length < 3) {
            toastError("Please enter at least 3 characters.");
            return;
          }
          setNameInput(account);
          setShowModal(true);
        }}
      />
      <Modal
        footer={{
          primary: {
            label: "unused"
          },
          footerComponent: (
            <ModalFooter>
              <SaveAndCancel
                analyticsEventName="Copy Account"
                saveButtonText="Okay"
                onCancel={() => setShowModal(false)}
                onSave={() => {
                  performCopy(nameInput);
                  setShowModal(false);
                }}
              />
            </ModalFooter>
          )
        }}
        header={`Copy Media Library Assets`}
        show={showModal}
        size="large"
        onHide={() => setShowModal(false)}
      >
        <StyledModalContent>
          <Alert role="alert" type="error">
            This will copy <strong>{selectedAccount}</strong> to{" "}
            <strong>{nameInput}</strong>. Are you sure?
          </Alert>
        </StyledModalContent>
      </Modal>
    </StyledInputArea>
  );
};
